// Module Federation requires an async boundary before the app touches shared
// singletons (react/react-dom), so the host can negotiate versions first.
import("./bootstrap");
export {};
